var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-12 text-center"},[(!_vm.isLogin)?_c('span',[_vm._v("自動登入中，請稍候")]):_vm._e(),(_vm.isLogin && _vm.loginSuccess)?_c('span',[_vm._v("登入成功，將自動跳轉至登入頁面")]):_vm._e(),(_vm.isLogin && !_vm.loginSuccess)?_c('span',[_vm._v("登入失敗，回到登入頁")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }